import Vue from 'vue'
import BaiduMap from 'vue-baidu-map'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import directive from "./directive";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import scroll from 'vue-seamless-scroll'
import CommonPlugin from './utils/common-plugin'
import { parseTime, resetForm, handleTree } from "@/utils/ruoyi";
import '@/styles/index.scss' // global css
import VueClipboard from 'vue-clipboard2'

import App from './App'
import store from './store'
import router from './router'
import dayjs from 'dayjs'
import _ from "lodash";
import Title from '@/components/Title'
import Pagination from '@/components/Pagination'
import Empty from '@/components/empty'
Vue.component("Empty", Empty)
Vue.component("Title", Title)
Vue.component("pagination", Pagination)

import '@/icons' // icon
import '@/permission' // permission control
import '@/styles/common.css'

Vue.prototype.$EventBus = new Vue()
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */
// 临时禁用 mock 系统，因为真实接口正常，mock 系统导致 JSON 解析错误
// import { mockXHR } from '../mock'
// if (process.env.NODE_ENV === 'development') {
//   mockXHR()
// }
Vue.prototype.dayjs = dayjs;
Vue.prototype._ = _;
Vue.prototype.parseTime = parseTime;
Vue.prototype.handleTree = handleTree;
Vue.prototype.resetForm = resetForm;
// set ElementUI lang to EN
Vue.use(ElementUI, { locale })
Vue.use(CommonPlugin)
Vue.use(directive);
Vue.use(scroll)
Vue.use(VueClipboard)
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)
Vue.use(BaiduMap, {
  ak: '此处为百度地图申请的密钥'
})
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
